module.exports = __webpack_public_path__ + "b0cea480ec0ced24e430055057b21b15.pdf";